import React from 'react';
import useDimensions from 'react-cool-dimensions';
import { ICON } from 'resources/constants/icons.enum';
import { ButtonCounter, Arrow, Wrapper } from './elements';

const IMAGE_WIDTH = 24;
const OVERLAP = 7;
const SPACE = 40;
const VISIBLE_IMAGE_WIDTH = IMAGE_WIDTH - OVERLAP;

type Props = {
  readonly className?: string;
  readonly expanded: boolean;
  readonly iconUrls: string[];
  readonly render: (iconUrl: string, iconPosition: number) => JSX.Element;
};

export function OverlapIcons({
  className,
  expanded,
  iconUrls,
  render,
}: Props): React.ReactElement {
  const { observe: ref, width } = useDimensions({
    onResize: ({ observe, unobserve }) => {
      // Triggered whenever the size of the target is changed...
      unobserve(); // To stop observing the current target element
      observe(); // To re-start observing the current target element
    },
  });
  const maxNumberOfIcons = Math.floor((width - SPACE) / VISIBLE_IMAGE_WIDTH);
  const iconsMissing = iconUrls.length - maxNumberOfIcons;
  const buttonCounterPosition = maxNumberOfIcons * VISIBLE_IMAGE_WIDTH;

  return (
    <Wrapper ref={ref} className={className}>
      {iconUrls.slice(0, maxNumberOfIcons).map((iconUrl, index) => {
        const iconPosition = index * VISIBLE_IMAGE_WIDTH;

        return render(iconUrl, iconPosition);
      })}
      {iconsMissing > 0 ? (
        <ButtonCounter key="bc" position={buttonCounterPosition}>
          {iconsMissing <= 99 ? `+${iconsMissing}` : '+99'}
        </ButtonCounter>
      ) : null}
      <Arrow $expanded={expanded} icon={ICON.keyboardArrowDown} key="icon" />
    </Wrapper>
  );
}
